<template>
	<div class="desktop-warning">
		<div class="text-center"><img src="../assets/img/bulevar-desktop.svg" alt="Bulevar Logo" class="logo" /></div>
		<h1>{{ t('txt_slogan') }}</h1>
		<h3>{{ t('txt_mobile_only') }}</h3>
		<p v-html="txt_desktop_description"></p>
		<h3>{{ t('txt_more_sparks') }}</h3>
		<div class="qr"><img src="../assets/img/qrbulevar.svg"></div>
		<h2>{{ t('txt_scan_now_and_start') }}</h2>
		<p><a target="_blank" href="https://join.bulevar.eu/en/general-terms-and-conditions-of-use-of-the-bulevar-web-application/">General terms and conditions</a> <a target="_blank" href="https://join.bulevar.eu/en/general-terms-and-conditions-of-use-of-the-bulevar-web-application/">Privacy policy</a></p>
	</div>
</template>

<script>
	import { useI18n } from 'vue-i18n';
	export default {
		name: "DesktopWarningPage",
		computed: {
			txt_desktop_description() {
				return this.$t('txt_desktop_description');
			},
		},
		setup() {
			const { t } = useI18n();
			return {
				t
			};
		},
	};
</script>

<style scoped>
.desktop-warning {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
	text-align: center;
	color: #FFFFFF;
	font-family: Arial, sans-serif;
	background-image: url('../assets/img/desktop-bg.svg');
	background-position: bottom center;
	background-repeat: repeat-x;
}

.desktop-warning h1 {
	font-size: 3.125rem;
	line-height: 2.75rem;
	margin-bottom: 3rem;
}
.desktop-warning h2 {
	font: normal normal normal 30px/36px Arial;
	letter-spacing: 0px;
	opacity: 1;
	max-width: 460px;
}
.desktop-warning h3 {
	font: normal normal normal 30px/34px Arial;
	letter-spacing: 0px;
	color: #29CCB1;
	opacity: 1;
}
.desktop-warning p {
	margin: 0 auto 0.5rem auto;
	max-width: 700px;
	font-size: 1.375rem;
	line-height: 1.75rem;
	strong {
		font-weight: bold;
		color: #29CCB1 !important;
	}
}
.desktop-warning .qr {
	width: 160px;
	height: 160px;
	border-radius: 5px;
	background: #FFFFFF;
	padding: 4px;
}
.desktop-warning a {
	font-size: 12px;
	color: #29CCB1;
}
</style>